// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"695af0e2","651":"4a500d28","999":"570da516"}[chunkId] + ".chunk.js";
};